import { connect } from "react-redux";

import { TableType } from "../../../Engine/Core/ModalManager/Modals/Utils/Types";
import { CandyDispatch, CandyThunkAction } from "../../../Engine/Core/Store/CandyReduxTypes";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath, createAbsolute } from "../../../../../Common/ModelPath/ModelPath";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { printExcelAction } from "../../../Engine/ActionCreators/FufUploadActionCreator";
import { showModalActionCreator } from "../../../Engine/Core/ModalManager/FormModalAction";
import {
    CombinatorType,
    FufCombineMethod,
} from "../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { formSilentSaveAction } from "../../../Engine/ActionCreators/FormActionCreators";
import { ModalOptions } from "../../../Engine/Core/ModalManager/IModalState";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";

import { DropDownButtonUploadFiles } from "./DropDownButtonUploadFiles";

export interface ImportProps {
    combinatorType?: CombinatorType;
    combineType?: FufCombineMethod.AddToEnd | FufCombineMethod.Merge;
    isImportByFuf?: boolean;
}

export interface DownloadExcelButtonContainerProps extends FormActionHandlerExecutionInjectableProps {
    pathToTable: string;
    viewModelSelect: ViewModelSelect;
    tableType: TableType.static | TableType.dynamic;
    acceptGFVs: string[];
    navigationPath?: string;
    getTypeId?: FormActionHandler;
    isOnlyAddToEnd: boolean;
    isOnlyReplace: boolean;
    currentInstancesCount?: number;
    commonImportOptions: ImportProps;
    importOptionsForExcel: ImportProps;
    importOptionsForXml: ImportProps;
}

export function getInstancesCount(path: AbsoluteModelPath): CandyThunkAction<number> {
    return (_, __, form) => {
        const instances = form.getChildren(path.toLegacyPath()) ?? [];
        return instances.length;
    };
}

function callGetTypeId(getTypeId: FormActionHandler, path: string): CandyThunkAction<ModalOptions> {
    return (_, __, form) => {
        // @ts-ignore
        const options: ModalOptions = getTypeId(form.getHelperFunctionsCallContext(), {
            bindingPath: path,
            field: "value",
        });
        return options;
    };
}

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
});

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: DownloadExcelButtonContainerProps) => ({
    downloadExcel: async () => await dispatch(printExcelAction(ownProps.pathToTable)),
    uploadExcel: async () => {
        if (ownProps.getTypeId !== undefined) {
            const options: ModalOptions = dispatch(callGetTypeId(ownProps.getTypeId, ownProps.pathToTable));
            options.isOnlyAddToEnd = ownProps.isOnlyAddToEnd;
            options.isOnlyReplace = ownProps.isOnlyReplace;
            options.getTypeId = ownProps.getTypeId;
            dispatch(showModalActionCreator(options));
        } else {
            const currentInstancesCount = dispatch(getInstancesCount(createAbsolute(ownProps.pathToTable)));
            dispatch(
                showModalActionCreator({
                    modalName: "LoadExcel",
                    acceptFiles: ["xls", "xlsx"],
                    currentInstancesCount: currentInstancesCount,
                    tableType: ownProps.tableType,
                    pathToTable: ownProps.pathToTable,
                    combineType:
                        ownProps.importOptionsForExcel?.combineType ??
                        ownProps.commonImportOptions.combineType ??
                        FufCombineMethod.AddToEnd,
                    combinatorType:
                        ownProps.importOptionsForExcel?.combinatorType ??
                        ownProps.commonImportOptions.combinatorType ??
                        CombinatorType.Default,
                    isImportByFuf:
                        ownProps.importOptionsForExcel?.isImportByFuf ?? ownProps.commonImportOptions.isImportByFuf,
                })
            );
        }
    },
    uploadXml: () => {
        if (ownProps.getTypeId !== undefined) {
            const options: ModalOptions = dispatch(callGetTypeId(ownProps.getTypeId, ownProps.pathToTable));
            options.modalName = "UploadSection";
            options.acceptFiles = ["xml"];
            options.isOnlyAddToEnd = ownProps.isOnlyAddToEnd;
            options.isOnlyReplace = ownProps.isOnlyReplace;
            options.getTypeId = ownProps.getTypeId;
            dispatch(showModalActionCreator(options));
        } else {
            const currentInstancesCount = dispatch(getInstancesCount(createAbsolute(ownProps.pathToTable)));
            dispatch(
                showModalActionCreator({
                    modalName: "LoadXml",
                    acceptFiles: ["xml"],
                    currentInstancesCount: currentInstancesCount,
                    tableType: ownProps.tableType,
                    pathToTable: ownProps.pathToTable,
                    combineType:
                        ownProps.importOptionsForXml?.combineType ??
                        ownProps.commonImportOptions.combineType ??
                        FufCombineMethod.AddToEnd,
                    combinatorType:
                        ownProps.importOptionsForXml?.combinatorType ??
                        ownProps.commonImportOptions.combinatorType ??
                        CombinatorType.Default,
                    isImportByFuf:
                        ownProps.importOptionsForXml?.isImportByFuf ?? ownProps.commonImportOptions.isImportByFuf,
                    acceptGFVs: ownProps.acceptGFVs,
                })
            );
        }
    },
    onSaveForm: () => dispatch(formSilentSaveAction),
});

export const DropdownButtonUploadFilesContainer = withFocusManagement(
    withControlDebugInfo(
        withFormActionHandlerExecution(
            withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(DropDownButtonUploadFiles))
        )
    )
);
